__turbopack_context__.v({
  "btn": "_2Krm_G_btn",
  "btn--m": "_2Krm_G_btn--m",
  "btn--s": "_2Krm_G_btn--s",
  "btn--xs": "_2Krm_G_btn--xs",
  "icon": "_2Krm_G_icon",
  "label": "_2Krm_G_label",
});
